module.exports = __webpack_public_path__ + "assets/img/admission-success-icon.2f67dfb8.png";